/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import ReactRouterPropTypes from 'react-router-prop-types';
import { hot } from 'react-hot-loader/root';
import { Auth, Hub } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import LoginBanner from './components/LoginBanner';
import MainRouter from './containers/MainRouter';
import { validateSession } from './services/authService';
import { consumeDeepLinkTarget } from './services/deepLinkTarget';
import theme from './styles/theme';

function App(props) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [storeId, setStoreId] = useState(null);
  const [username, setUsername] = useState(undefined);

  useEffect( async() => {
    //Okta/cognito auth events
    Hub.listen('auth', ({payload: {event, data}}) => {
      console.log(event)
      switch (event) {
        case 'signIn':
          setIsLoggedIn(true);
          break;
        case 'signOut':
          setIsLoggedIn(false);
          break;
        case 'tokenRefresh':
          break;
        default:
          setIsLoggedIn(false);
      }
    })
    //inStore custom auth events
    Hub.listen('storeAuth', async ({payload: {event, data}}) => {
      console.log(event)
      switch (event) {
        case 'signIn':
          const authTime = moment();
          const userInfo = jwtDecode(data);
          const storeNo = userInfo.data.storeId
          await localStorage.setItem('isInStore', true);
          await localStorage.setItem('authTime', authTime);
          await localStorage.setItem('token', data);
          if (storeNo === "Dev" || parseInt(storeNo) === 1){
            setIsAdmin(true)
            setStoreId(1)
          } else {
            console.log('settingStore', storeNo)
            setStoreId(parseInt(storeNo))
          }
          setIsLoggedIn(true);
          break;
        case 'expired':
          localStorage.clear();
          await alert('Your session has expired, press Ok to sign in.')
          setIsLoggedIn(false);
          break;
        case 'signOut':
          localStorage.clear();
          setIsLoggedIn(false)
          break;
        default:
          setIsLoggedIn(false);
      }
    })

    initiateAuth();
  }, [])

  useEffect(() => {
    const { history } = props;

    if (isLoggedIn){
      const target = consumeDeepLinkTarget();
      history.push(target || '/home')
    } else {
      history.push('/')
    }
  }, [isLoggedIn])

  const initiateAuth = async () => {
    try {
      const isValidated = await validateSession();
      const isInStore = await localStorage.getItem('isInStore')
      if (isValidated && isInStore){
        setIsLoggedIn(true);
      } else if (isValidated){
        const sesh = await (await Auth.currentSession()).getIdToken();
        console.log({sesh})
        const { locale } = sesh.payload
        setStoreId(locale);
        setIsAdmin(!!locale);
        setUsername(sesh.payload['cognito:username']);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    } catch(error){
      console.log(`auth error: ${error}`)
      setIsLoggedIn(false);
    }
  }


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {!isLoggedIn ? <LoginBanner /> : null}
        <MainRouter
          {...props}
          isLoggedIn={isLoggedIn}
          isAdmin={isAdmin}
          storeId={storeId}
          username={username}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
//note this is the node_env which by default is set to development, not related to the stage.
export default (process.env.NODE_ENV === 'development'
  ? hot(withRouter(App))
  : withRouter(App));
App.propTypes = {
  history: ReactRouterPropTypes.history,
}